import axios from "../api/axiosInstance";


export const GetAllPost = async () => {
    return await axios.get("/Post/GetPostList");
};


export const GetPostById = async (id) => {
    return await axios.get("/Post/GetPostById", {
        params: { id }
    });
};


export const AddPost = async (model) => {
    return await axios.post("/Post/AddPost", model);
};


export const UpdatePost = async (model) => {
    return await axios.post("/Post/UpdatePost", model);
};


export const RemovePost = async (id) => {
    return await axios.post("/Post/RemovePost", null, {
        params: { id }
    });
};